import { PlayerComparison } from '../components/PlayerComparison.tsx';

/** The player-comparison screen's own route (T-051) — no squad dependency,
 * same as `/fixtures` and `/tracker`: any two to four ingested players can
 * be compared regardless of whether a squad is loaded. */
export function CompareRoute() {
  return <PlayerComparison />;
}
